import { MMKV } from 'react-native-mmkv';
import { StateStorage } from 'zustand/middleware';
import { MMKVStoreKeyMap } from './mmkvStoreKeyMap';

export const mmkvWeatherStore = new MMKV({
  id: MMKVStoreKeyMap.weatherStore,
});

export const zustandWeatherStore: StateStorage = {
  setItem(name: string, value: string) {
    return mmkvWeatherStore.set(name, value);
  },
  getItem(name: string) {
    const value = mmkvWeatherStore.getString(name);
    return value ?? null;
  },
  removeItem(name: string) {
    return mmkvWeatherStore.delete(name);
  },
};
